var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:_vm.buildColor,attrs:{"title":_vm.buildTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }